import PropTypes from 'prop-types';
import { enhancedConnect } from "../../../enhancedConnect";
export var CrudeOperations;
(function (CrudeOperations) {
  CrudeOperations["EQ"] = "===";
  CrudeOperations["NEQ"] = "!==";
  CrudeOperations["GTE"] = ">";
  CrudeOperations["TRUTHY"] = "truthy";
  CrudeOperations["GT"] = ">=";
  CrudeOperations["LTE"] = "<=";
  CrudeOperations["LT"] = "<";
  CrudeOperations["CONTAINS"] = "Contains";
})(CrudeOperations || (CrudeOperations = {}));
var checkLogic = function checkLogic(operation, valueA, valueB) {
  switch (operation) {
    case CrudeOperations.EQ:
      return valueA === valueB;
    case CrudeOperations.NEQ:
      return valueA !== valueB;
    case CrudeOperations.TRUTHY:
      return !!valueA === valueB;
    case CrudeOperations.GTE:
      return valueA >= valueB;
    case CrudeOperations.GT:
      return valueA > valueB;
    case CrudeOperations.LTE:
      return valueA <= valueB;
    case CrudeOperations.LT:
      return valueA < valueB;
    case CrudeOperations.CONTAINS:
      return Array.isArray(valueA) && valueA.indexOf(valueB) !== -1;
    default:
      throw new Error('Bad Operation');
  }
};
var _CrudeLogic = function _CrudeLogic(_ref) {
  var children = _ref.children,
    operation = _ref.operation,
    valueA = _ref.valueA,
    valueB = _ref.valueB;
  return checkLogic(operation, valueA, valueB) ? children : null;
};
export var CrudeLogic = enhancedConnect({
  children: PropTypes.node,
  operation: PropTypes.oneOf(Object.values(CrudeOperations)),
  valueA: PropTypes.any,
  valueB: PropTypes.any
})(_CrudeLogic);